const listagem = (state) => {
  return state.lista || []
}

const mapper = (state) => {
  return state.mapper || {}
}

const loading = (state) => {
  return state.loading
}

const dataAtualizacao = (state) => {
  return state.data_atualizacao
}

export { listagem, mapper, loading, dataAtualizacao }
